import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { ButtonSecBox } from './ButtonSecondary.style';

type TButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
  typeSubmit: boolean;
  textToolTip?: string;
};
const ButtonSecondary: React.FC<TButtonProps> = ({
  onClick,
  disabled = false,
  label,
  typeSubmit,
  textToolTip = '',
}) => {
  return (
    <>
      {typeSubmit ? (
        <Tooltip title={textToolTip} arrow>
          <ButtonSecBox type="submit" disabled={disabled} onClick={onClick}>
            {label}
          </ButtonSecBox>
        </Tooltip>
      ) : (
        <Tooltip title={textToolTip} arrow>
          <ButtonSecBox disabled={disabled} onClick={onClick}>
            {label}
          </ButtonSecBox>
        </Tooltip>
      )}
    </>
  );
};

export default ButtonSecondary;
